/**
 * Copyright © 2026 Adnuntius AS.
 * UI-Router state declarations.
 */
import _ from 'lodash';
import {Ng2StateDeclaration} from '@uirouter/angular';
import {AdminResourceItemRoutePageComponent} from '../../common/controller/admin-resource-item-route-page.component';
import {adminResourceItemRouteResolve} from '../../common/controller/admin-resource-routing';
import {collectStatesFromProvider, AdnRouterHelperApi} from '../../routing/state-utils';
import {stateTitleView} from '../../common/directives/html/state-title.component';
import {NotificationPreferencesResource} from '../../../components/api/resources/resource/notification-preference.resource';


export function notificationPreferencesStates(adnRouterHelper: AdnRouterHelperApi): Ng2StateDeclaration[] {
  return collectStatesFromProvider(function register($stateProvider, adnRouterHelperProvider) {
    const rh = adnRouterHelperProvider.$get().createRouterHelper(
      'notification-preferences.notification-preferences',
      NotificationPreferencesResource,
      'app.adm',
      'app/admin',
      null
    );
    $stateProvider.state('app.adm.notification-preferences', _.merge({}, rh.modelCommsItem({
      resolve: _.merge({}, adminResourceItemRouteResolve('notification-preferences-edit', 'edit'), {
        model: function() {
          return adnRouterHelper.services.resource(NotificationPreferencesResource).get().$promise;
        }
      }),
      views: {
        'content@app': {
          component: AdminResourceItemRoutePageComponent,
          bindings: {item: 'adminResourceItemKey', variant: 'adminResourceItemVariant'}
        }
      }
    }), {
      url: '/notification-preferences',
      views: {
        'title@app': stateTitleView()
      }
    }));
  }, adnRouterHelper);
}
